module.exports = __webpack_public_path__ + "img/icdeposit.1032d816.png";